"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncAction = exports.message = void 0;
var message = function (type, payload) { return ({
    type: type,
    payload: payload,
}); };
exports.message = message;
var asyncAction = function (nexo, action, payload) {
    return new Promise(function (resolve) {
        var unsuscribe = nexo.suscribe(action, function (response) {
            resolve(response);
            unsuscribe();
        });
        nexo.dispatch((0, exports.message)(action, payload));
    });
};
exports.asyncAction = asyncAction;
